import React, { Component, createContext } from 'react';
import classnames from 'classnames';
import { bool, node, string } from 'prop-types';
import mergeWith from 'lodash/mergeWith';

import Code from '@components/Code/Code';
import { resetOptions, classHandler } from './utils';
import styles from './ShowCase.css';

const { Provider, Consumer } = createContext();

class ShowCase extends Component {
  static propTypes = {
    children: node,
    className: string,
    codeTemplate: string,
    isLast: bool,
  }

  state = {
    codeViewOpened: false,
    selectedOptions: {},
  }

  codeSample = null;

  handleOptionSelect = newOption => {
    this.setState(prevState => {
      let componentOptions = newOption.options;

      if (newOption.type === 'checkbox') {
        const newValidOptions = newOption.checked ?
          newOption.options :
          newOption.uncheckedOptions || resetOptions(newOption.options);

        componentOptions = mergeWith(prevState.selectedOptions, newValidOptions, classHandler);
      }

      return { selectedOptions: { ...prevState.selectedOptions, ...componentOptions }};
    });
  }

  toggleCodeView = () => {
    const { codeViewOpened } = this.state;

    this.setState({
      codeViewOpened: !codeViewOpened
    });
  }

  renderCodeSample = () => {
    const { codeViewOpened } = this.state;

    const codeContainerClass = classnames(
      {'code-opened': codeViewOpened},
      styles.codeContainer,
      'flex',
      'flex-justify-center',
      'flex-column'
    );

    return(
      <div className={codeContainerClass}>
        <Code codeSample={this.codeSample}/>

        <div className="flex flex-align-center flex-justify-center">
          <button onClick={this.toggleCodeView}>
            <span>...</span>
          </button>
        </div>
      </div>
    );
  }

  render () {
    const { isLast, children, className, codeTemplate } = this.props;
    const { selectedOptions } = this.state;

    // Todo: Make code generator dynamic;
    if (codeTemplate) {
      this.codeSample = codeTemplate;
    }

    const wrapperClasses = classnames(
      styles.wrapper,
      'flex',
      'flex-column',
      className,
      {'last': isLast}
    );

    return (
      <Provider
        value={{
          handleOptionSelect: this.handleOptionSelect,
          selectedOptions: selectedOptions,
          bgColor: selectedOptions.bgColor,
          codeSample: this.codeSample,
        }}>
          <div className={wrapperClasses}>
            {children}
            { codeTemplate && this.renderCodeSample() }
          </div>
      </Provider>
    );
  }
}

export const ShowCaseConsumer = Consumer;
export default ShowCase;



// WEBPACK FOOTER //
// ./src/components/ShowCase/ShowCase.js